// Dependency-free, so the SPA can build Vault links without bundling the API client.

/** The Vault this deployment reads; its UI serves document links, its API the calls in `client.ts`. */
export const VEEVA_VAULT_ORIGIN = 'https://ahpromo.veevavault.com'

/** The Vault UI search for a document number, such as a work order's distribution package code. */
export const veevaVaultSearchLink = (code: string): string =>
	`${VEEVA_VAULT_ORIGIN}/ui/#search?q=${encodeURIComponent(code)}`
